"use client";

import { FC } from "react";

interface IndicesHeaderProps {
  expiry?: string;
  title?: string;
  heading?: string;
}

const formatDate = (dateString: string | undefined): string => {
  if (!dateString?.trim()) return "";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

export const IndicesHeader: FC<IndicesHeaderProps> = ({
  expiry,
  title,
  heading,
}) => {
  const headingText = heading ?? title ?? "Indices insights";
  const expiryLabel = formatDate(expiry) || "-";

  return (
    <div className="flex items-center justify-between">
      <h2 className="text-xl font-medium md:text-[20px] text-[18px] text-[#1a1a1a]">
        {headingText}
      </h2>
      <div className=" flex items-center justify-center rounded-[4px] p-2 bg-[#F4D8CD] md:h-[36px] h-[30px]">
        <span className="md:text-[14px] text-[12px] font-[400px] text-[#893510]">
          Expiry: {expiryLabel}
        </span>
      </div>
    </div>
  );
};

